
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pengelolaan-kinerja/konfirmasi-profil",
      function () {
        return require("private-next-pages/pengelolaan-kinerja/konfirmasi-profil.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pengelolaan-kinerja/konfirmasi-profil"])
      });
    }
  